<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div>
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <h5 class="card-title" id="accordion">Filtrar leilões</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="cpf_cnpj">Leilão id</label>
              <input class="form-control" v-model="leilao_id" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <button type="button" class="btn btn-primary" @click="buscarLotes">Buscar</button>
              <button style="margin-left: 15px" type="button" class="btn btn-default" @click="limparFiltros">Limpar filtros</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button style="margin-left: 5px" data-dismiss="modal" aria-hidden="true" @click="print" class="btn btn-info">
      Imprimir
      <i style="margin-left: 5px" class="fa-solid fa-print"></i>
    </button>

    <button style="margin-left: 5px" data-dismiss="modal" aria-hidden="true" @click="exportToPDF" class="btn btn-primary">
      Salvar
      <i style="margin-left: 5px" class="fa-solid fa-file-pdf"></i>
    </button>

    <div id="printMe" ref="document">
      <div v-if="leilao && leilao.lotes && leilao.lotes.length > 0" style="text-align: center" class="report-header">
        <div style="width: 100%; height: 100px; display: flex; justify-content: center; align-items: center; margin-bottom: 0px">
          <img src="/images/logo.png" style="width: 100%; max-width: 120px" class="im-logo" />
        </div>
        <div style="display: flex; justify-content: center; align-items: center; margin-top: 0px">
          <h3>RELATÓRIO DE VENDA - LEILÃO {{ leilao.comitente.nome }}</h3>
        </div>
        <span style="font-weight: bold;k">Relatório gerado {{ formatDateDiaSemana() }}</span>
      </div>
      <br />
      <!-- CARD LOTE-->
      <div v-if="leilao && leilao.lotes && leilao.lotes.length > 0" v-for="lote in leilao.lotes" :key="lote" :value="lote" class="lote-card">
        <div class="card p-2">
          <div class="row">
            <div class="col-lg-12" style="text-align: left" id="detalhes">
              <div style="padding-left: 25px; padding-top: -3px !important; margin-top: -6px !important">
                <div style="margin-top: 0px; line-height: 25px" class="myBoard">
                  <div>
                    <b style="color: #4a4949; font-size: 18px">LOTE {{ lote.lote_numero + " - " + lote.lote_titulo }}</b>
                  </div>

                  <div>
                    <b>Houve disputa?&nbsp;</b>
                    <span v-if="lote.lances.length > 1">Sim, {{ lote.lances.length }} lances</span>
                    <span v-else>Não</span>
                  </div>

                  <div>
                    <b>Avaliação:&nbsp;</b>
                    <span>R$ {{ toCurrency(lote.lote_avaliacao) }}</span>
                  </div>

                  <div>
                    <b>Maior lance:&nbsp;</b>
                    <span>R$ {{ toCurrency(lote.lote_lance) }}</span>
                  </div>

                  <div>
                    <b>Comissão:&nbsp;</b>
                    <span>{{ lote.lote_comissao }}% - R$ {{ toCurrency((lote.lote_comissao / 100) * lote.lote_lance) }}</span>
                  </div>

                  <div>
                    <b>ICMS:&nbsp;</b>
                    <span>{{ lote.lote_icms }}% - R$ {{ toCurrency((lote.lote_icms / 100) * lote.lote_lance) }}</span>
                  </div>

                  <div>
                    <b>Taxa adm.:&nbsp;</b>
                    <span>R$ {{ toCurrency(leilao.leilao_taxa_administrativa) }}</span>
                  </div>

                  <div>
                    <b>Total leiloeiro:&nbsp;</b>
                    <span>
                      R$

                      {{ toCurrency(calcularTotalLeiloeiro(lote)) }}

                      <!--
                      {{
                        toCurrency(
                          (lote.lote_comissao / 100) * lote.lote_lance + (lote.lote_icms / 100) * lote.lote_lance + leilao.leilao_taxa_administrativa
                        )
                      }}
                    --></span>
                  </div>

                  <div>
                    <b>Total a pagar:&nbsp;</b>
                    <span>
                      {{ toCurrency(calcularTotalLeiloeiro(lote) + lote.lote_lance) }}

                      <!--
                      {{
                        toCurrency(
                          (lote.lote_comissao / 100) * lote.lote_lance +
                            (lote.lote_icms / 100) * lote.lote_lance +
                            leilao.leilao_taxa_administrativa +
                            lote.lote_lance
                        )
                      }}
                      -->
                    </span>
                  </div>

                  <div>
                    <b>Apelido:&nbsp;</b>
                    <span>{{ lote.user.apelido }}</span>
                  </div>

                  <div>
                    <b>Email:&nbsp;</b>
                    <span>{{ lote.user.email }}</span>
                  </div>

                  <div>
                    <b>Arrematante:&nbsp;</b>
                    <span>{{ lote.user.cadastro.nome_completo }}</span>
                  </div>

                  <div>
                    <b>Estado civil:&nbsp;</b>
                    <span>{{ lote.user.cadastro.estado_civil }}</span>
                  </div>

                  <div>
                    <b>CPF:&nbsp;</b>
                    <span>{{ lote.user.cadastro.cpf }}</span>
                  </div>

                  <div>
                    <b>RG:&nbsp;</b>
                    <span>{{ lote.user.cadastro.rg }}</span>
                  </div>

                  <div>
                    <b>Fone(s):&nbsp;</b>
                    <span>
                      {{ formatarTelefone(lote.user.cadastro.telefone_celular) }} &nbsp; {{ formatarTelefone(lote.user.cadastro.telefone_fixo) }}
                    </span>
                  </div>
                  <div>
                    <b>Endereço:&nbsp;</b>
                    <span>{{ lote.user.cadastro.endereco }}, {{ lote.user.cadastro.endereco_num }} - {{ lote.user.cadastro.endereco_bairro }}</span>
                  </div>
                  <div>
                    <b>Cidade:&nbsp;</b>
                    <span>
                      {{ lote.user.cadastro.cidade.nome }}/{{ lote.user.cadastro.estado.sigla }} - CEP: {{ lote.user.cadastro.endereco_cep }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card p-2 report-footer" v-if="leilao && leilao.lotes && leilao.lotes.length > 0">
        <div class="row">
          <div class="col-lg-12" style="text-align: left; padding-left: 25px; padding-top: -3px !important; margin-top: -6px !important">
            <div>
              <b>QTD LOTES VENDIDOS:&nbsp;</b>
              <span>{{ leilao.lotes.length }}</span>
            </div>
            <div>
              <b>TOTAL VENDIDO:&nbsp;</b>
              <span>R$ {{ calcularTotalArrematacao() }}</span>
            </div>
            <div>
              <b>TOTAL COMISSÃO:&nbsp;</b>
              <span>R$ {{ calcularValorComissao() }}</span>
            </div>
            <div>
              <b>TOTAL COMISSÃO + TAXA:&nbsp;</b>
              <span>R$ {{ toCurrency(calcularTotalComissaoTaxa()) }}</span>
            </div>
            <div>
              <b>TOTAL ICMS:&nbsp;</b>
              <span>R$ {{ toCurrency(calcularTotalICMS()) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auxFormatacao from "../../controller/auxFormatacao.js";
import sweetAlert from "../../controller/sweetAlert.js";
import currencyController from "../../controller/currencyController.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  props: ["estados"],

  mixins: [sweetAlert, Swal, AuxController, currencyController, auxFormatacao],

  components: {Loading},

  data() {
    return {
      isLoading: false,
      leilao_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      lotes: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      venda_direta: false,
      relatorio_selecionado: "",
      listar_lotes: true,
      titulo: "",
      descricao: "",
      dataInicio: "",
      dataFim: "",
      exibir_propostas: false,
      processos: "",
      comitentes: "",
      lote_selecionado: "",
      mesInicio: "",
      mesFim: "",
      tipo_leilao: "",
      comitente_selecionado: "",
      leilao_id: "",
      leilao: "",
    };
  },

  mounted() {
    console.log(this.docs_tipo_usuario);

    this.dataInicio = this.formatSelectedDate(new Date());
    this.dataFim = this.formatSelectedDate(new Date());

    this.mesInicio = moment(new Date()).format("YYYY-MM");
    this.mesFim = moment(new Date()).format("YYYY-MM");
  },

  methods: {
    calcularTotalLeiloeiro(lote) {
      let comissao = this.roundToTwoDecimals((lote.lote_comissao / 100) * lote.lote_lance);
      let icms = this.roundToTwoDecimals((lote.lote_icms / 100) * lote.lote_lance);
      let taxa_adm = this.leilao.leilao_taxa_administrativa;

      return comissao + icms + taxa_adm;
      //toCurrency((lote.lote_comissao / 100) * lote.lote_lance + (lote.lote_icms / 100) * lote.lote_lance + leilao.leilao_taxa_administrativa);
    },

    /*
    exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 0.2,
        filename: "document.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      });
    },*/
    async exportToPDF() {
      this.isLoading = true;
      const reportElement = this.$refs.document;

      if (!reportElement) {
        // ... (código de erro)
        return;
      }

      reportElement.classList.add("pdf-render-view");

      try {
        const pdf = new jsPDF({ unit: "pt", format: "letter" });
        const pdfWidth = pdf.internal.pageSize.getWidth();
        let currentY = 40;

        // --- PARTE 1: DESENHANDO O CABEÇALHO MANUALMENTE ---
        // (Esta parte permanece a mesma, já está funcionando bem)
        const logoEl = reportElement.querySelector(".im-logo");
        if (logoEl) {
          const canvas = await html2canvas(logoEl, { backgroundColor: null });
          const logoDataUrl = canvas.toDataURL("image/png");
          const logoWidthInPdf = 90;
          const logoAspectRatio = canvas.height / canvas.width;
          const logoHeightInPdf = logoWidthInPdf * logoAspectRatio;
          const logoX = (pdfWidth - logoWidthInPdf) / 2;

          pdf.addImage(logoDataUrl, "PNG", logoX, currentY, logoWidthInPdf, logoHeightInPdf);
          currentY += logoHeightInPdf + 15;
        }

        const titleEl = reportElement.querySelector(".report-header h3");
        if (titleEl) {
          pdf.setFontSize(14).setFont(undefined, "bold");
          pdf.text(titleEl.innerText, pdfWidth / 2, currentY, { align: "center" });
          currentY += 20;
        }

        const subtitleEl = reportElement.querySelector(".report-header span");
        if (subtitleEl) {
          pdf.setFontSize(9).setFont(undefined, "normal");
          const dataAtual = new Date();
          const dataFormatada = dataAtual.toLocaleDateString("pt-BR", { year: "numeric", month: "long", day: "numeric" });
          const horaFormatada = dataAtual.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
          const textoData = `Relatório gerado ${dataFormatada} - ${horaFormatada}`;

          pdf.text(textoData, pdfWidth / 2, currentY, { align: "center" });
          currentY += 30;
        }

        // --- PARTE 2: DESENHANDO O RESTO DO CONTEÚDO AUTOMATICAMENTE ---

        const contentContainer = document.createElement("div");
        // A LINHA CORRIGIDA ESTÁ AQUI:
        contentContainer.classList.add("pdf-render-view");

        const lotCards = reportElement.querySelectorAll(".lote-card");
        const footer = reportElement.querySelector(".report-footer");
        lotCards.forEach((card) => contentContainer.appendChild(card.cloneNode(true)));
        if (footer) contentContainer.appendChild(footer.cloneNode(true));

        await pdf.html(contentContainer, {
          y: currentY,
          x: 15,
          width: 580,
          windowWidth: 650,
          autoPaging: "text",
        });

        pdf.save(`relatorio-leilao-${this.leilao_id}.pdf`);
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
        this.showErrorMessageWithButton("Erro", "Não foi possível gerar o PDF.");
      } finally {
        this.isLoading = false;
        reportElement.classList.remove("pdf-render-view");
      }
    },

    calcularTotalICMS() {
      let total = 0;

      for (let i = 0; i < this.leilao.lotes.length; i++) {
        total = total + (this.leilao.lotes[i].lote_icms / 100) * this.leilao.lotes[i].lote_lance;
      }

      return total;
    },

    calcularTotalComissaoTaxa() {
      let total = 0;

      for (let i = 0; i < this.leilao.lotes.length; i++) {
        /*
        total =
          total +
          this.roundToTwoDecimals((this.leilao.lotes[i].lote_comissao / 100) * this.leilao.lotes[i].lote_lance) +
          this.leilao.leilao_taxa_administrativa;
          */
        total = total + (this.leilao.lotes[i].lote_comissao / 100) * this.leilao.lotes[i].lote_lance + this.leilao.leilao_taxa_administrativa;
      }

      return total;
    },

    roundToTwoDecimals(num) {
      return Math.round(num * 100) / 100;
    },

    upperCase(string) {
      if (!string) {
        return string;
      }

      return string.toUpperCase();
    },

    ExportExcel(type, fn, dl) {
      let nome_arquivo = "Relatório arremate";

      /*
      if (this.lote_selecionado) {
        nome_arquivo = nome_arquivo + " - lote " + this.lote_selecionado.lote_numero;
      }
      */

      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || (nome_arquivo + "." || "SheetJSTableExport.") + (type || "xlsx"));
    },

    calcularTaxaAdm() {
      let total_taxa_adm = 0;

      for (let i = 0; i < this.lotes.length; i++) {
        total_taxa_adm += this.lotes[i].leilao.leilao_taxa_administrativa;
      }

      return this.toCurrency(total_taxa_adm);
    },

    calcularValorComissao() {
      let total_arrematacao = 0;

      for (let i = 0; i < this.leilao.lotes.length; i++) {
        //total_arrematacao += this.roundToTwoDecimals((this.leilao.lotes[i].lote_comissao / 100) * this.leilao.lotes[i].lote_lance);
        total_arrematacao += (this.leilao.lotes[i].lote_comissao / 100) * this.leilao.lotes[i].lote_lance;
      }

      return this.toCurrency(total_arrematacao);
    },

    calcularTotalArrematacao() {
      let total_arrematacao = 0;

      for (let i = 0; i < this.leilao.lotes.length; i++) {
        total_arrematacao += this.leilao.lotes[i].lote_lance;
      }

      return this.toCurrency(total_arrematacao);
    },

    print() {
      const options = {
        name: "Relatório leilão",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: [
          "../../css/print.css",
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
        ],
        timeout: 1000, // default timeout before the print window appears
        autoClose: true, // if false, the window will not close after printing
        windowTitle: window.document.title, // override the window title
      };

      //htmlToPaper("printMe");

      this.$htmlToPaper("printMe", options);
    },

    formatSelectedDate(date) {
      return moment(date).format("yyyy-MM-DD");
    },

    buscarComitentes() {
      this.isLoading = true;

      let data = {
        inicio: 0,
        tamanho: 100000,
        alfabetico: true,
      };

      axios
        .post(`/admin/comitente/search`, data)
        .then((response) => {
          this.comitentes = response.data.comitentes;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarprocessos() {
      this.isLoading = true;

      let data = {
        inicio: 0,
        tamanho: 100000,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          this.processos = response.data.processos;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    setListarProposta() {
      this.exibir_propostas = false;
    },

    getValorLance(lance) {
      return "R$" + this.toCurrency(lance.valor);
    },

    getValorLanceSemConversao(lance) {
      return lance.valor;
    },

    getLoteDescription(description) {
      if (typeof description == "string" && description.includes("</")) {
        //console.log("Entrou no IF");
        var div = document.createElement("div");
        div.innerHTML = description;
        description = div.textContent || div.innerText || "";
      } else {
        // console.log("Descricao fora do IF");
      }

      if (description && description.length > 210) {
        return description.substring(0, 210) + "...";
      }
      return description;
    },

    getFormatedText(text, size) {
      if (text && text.length > size) {
        return text.substring(0, size) + "...";
      } else {
        return text;
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    buscarLotes() {
      this.isLoading = true;

      let data = {
        id: this.id,
        comitente_id: this.comitente,
        titulo: this.titulo,
        descricao: this.descricao,
        inicio: this.inicio,
        tamanho: 10000000,
        executado: this.executado,
        tipo_leilao: this.tipo_leilao,
        leilao_id: this.leilao_id,
      };

      if (this.mesInicio) {
        data.inicio_mes = moment(this.mesInicio, "YYYY-MM").format("MM");
        data.inicio_ano = moment(this.mesInicio, "YYYY-MM").format("yyyy");
      }

      if (this.mesFim) {
        data.fim_mes = moment(this.mesFim, "YYYY-MM").format("MM");
        data.fim_ano = moment(this.mesFim, "YYYY-MM").format("yyyy");
      }

      if (this.comitente_selecionado) {
        data.comitente_id = this.comitente_selecionado.id;
      }

      /*
      if (this.dataInicio) {
        console.log("Formatando");
        console.log(this.dataInicio);

        data.data_inicio = this.formatDateToSearch(this.dataInicio);
      }

      if (this.dataFim) {
        data.data_fim = this.formatDateToSearchTime(this.dataFim);
      }
    */

      console.log(data);

      axios
        .post(`/admin/relatorio/venda/search`, data)
        .then((response) => {
          this.leilao = response.data.leilao;

           this.isLoading = false;

          if (this.leilao && this.leilao.lotes && this.leilao.lotes.length == 0) {
            this.showErrorMessageWithButton("Ops...", "Nenhum lote desse leilão recebeu lance.");
          }

          console.log("Leilao");
          console.log(this.leilao);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatDateDiaSemana(date) {
      date = new Date();

      let formatted = moment(date).locale("pt-br").format("ddd, DD/MM/YYYY - HH:mm[h]");

      // Capitaliza a primeira letra
      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    },

    formatDateMes(date) {
      return moment(date).format("MM-YY");
    },

    formatDateToSearch(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD 00:00:00");
    },

    formatDateToSearchTime(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD 23:59:59");
    },

    changePraca(leilao, num_praca) {
      console.log(leilao.leilao_1_realizado);
      console.log(num_praca);

      this.leilao_selecionado = leilao;

      let valor = -1;

      //FECHANDO PRACA
      if (num_praca == 2 && leilao.leilao_2_realizado && !leilao.leilao_1_realizado) {
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else if (num_praca == 3 && leilao.leilao_3_realizado && !leilao.leilao_2_realizado) {
        leilao.leilao_3_realizado = false;
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else if (num_praca == 4 && leilao.leilao_4_realizado && !leilao.leilao_3_realizado) {
        leilao.leilao_4_realizado = false;
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else {
        if (num_praca == 1) {
          valor = this.convertToTiny(leilao.leilao_1_realizado);
        } else if (num_praca == 2) {
          valor = this.convertToTiny(leilao.leilao_2_realizado);
        } else if (num_praca == 3) {
          valor = this.convertToTiny(leilao.leilao_3_realizado);
        } else if (num_praca == 4) {
          valor = this.convertToTiny(leilao.leilao_4_realizado);
        }

        let data = {
          leilao_id: leilao.id,
          num_praca: num_praca,
          valor: valor,
        };

        console.log(data);

        axios
          .post(`/admin/leilao/fechar_praca`, data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              if (response.data.leilao_aberto) {
                leilao.leilao_encerrado = false;
              }

              if (response.data.leilao_encerrado) {
                leilao.leilao_encerrado = true;
              }

              this.showSuccessMessage("Status atualizado");
              this.forceDisconnect();
            } else {
              console.log("Erro na request");
              this.showErrorMessageWithButton("Ops...", response.data.msg);
              this.buscarLotes();
            }

            //window.location.reload();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
            this.isLoading = false;
          });
      }
    },

    forceDisconnect() {
      let data = {
        leilao_id: this.leilao_selecionado.id,
      };

      axios.post(process.env.MIX_VUE_APP_AUDITORIO + `/emit_disconnect`, data).then((response) => {});
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, leilao) {
      this.leilao_selecionado = leilao;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 250;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    changeStatus(leilao, atual) {
      console.log(leilao);

      this.leilao_selecionado = leilao;

      let data = {
        leilao_id: leilao.id,
        leilao_retirado: this.convertToTiny(leilao.leilao_retirado),
        leilao_encerrado: this.convertToTiny(leilao.leilao_encerrado),
        leilao_suspenso: this.convertToTiny(leilao.leilao_suspenso),
      };

      console.log(data);

      axios
        .post(`/admin/leilao/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");
          this.forceDisconnect();

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    ocultarLeilao(leilao) {
      let mensagem = "";

      if (!leilao.leilao_oculto) {
        mensagem =
          "<h3 style='color:#616060'>Ao <b style='color: green'>desocultar</b> o leilão, todos os lotes também serão desocultados. <br/><b>Confirma sua escolha?</b></h3>";
      } else {
        mensagem =
          "<h3 style='color:#616060'>Ao <b style='color: red'>ocultar</b> o leilão, todos os lotes serão marcados com oculto. <br/><b>Confirma sua escolha?</b></h3>";
      }

      this.$swal
        .fire({
          title: mensagem,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, confirmar!",
        })
        .then((result) => {
          if (result.value) {
            let data = {
              leilao_id: leilao.id,
              leilao_oculto: this.convertToTiny(leilao.leilao_oculto),
            };

            console.log(data);

            axios
              .post(`/admin/leilao/ocultar_leilao`, data)
              .then((response) => {
                this.showSuccessMessage("Status atualizado");

                //window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
                this.isLoading = false;
              });
          } else {
            leilao.leilao_oculto = !leilao.leilao_oculto;
          }
        });
    },

    handler() {
      alert("Right!");
    },

    getUrlImportarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/importar";
    },

    getUrlFotos(leilao) {
      if (leilao.lotes && leilao.lotes.length) {
        return "/admin/fotos/" + leilao.lotes[0].id + "";
      }
    },

    getUrlPub(leilao) {
      return "/admin/publicacao/" + leilao.id + "";
    },

    getUrlDocumentos(leilao) {
      return "/admin/documentos/" + leilao.id + "";
    },

    getUrlListarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes";
    },

    getUrlAddLote(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/cadastrar_lote";
    },

    getUrlLogs(leilao) {
      return "/admin/leilao/" + leilao.id + "/logs";
    },

    limparFiltros() {
      this.id = "";
      this.estado = "";
      this.cidade = "";
      this.comitente = "";
      this.titulo = "";
      this.descricao = "";
      //this.local = "EXCLUSIVAMENTE ONLINE";
      this.local = "";
      this.tipo = "";
      this.teste = 0;
      this.executado = "";
      this.processo = "";
      this.dataInicio = "";
      this.dataFim = "";

      this.comitente_selecionado = null;
      this.tipo_leilao = null;
      this.leilao_id = null;

      this.mesInicio = "";
      this.mesFim = "";

      document.getElementById("dataInicio").value = "";
      document.getElementById("dataFim").value = "";

      //this.buscarLotes();
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(leilao) {
      this.leilao_selecionado = leilao;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      }
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          this.buscarLotes();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    getImageLote(lote) {
      if (lote.thumb) {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + lote.thumb.path + "/" + lote.thumb.img;
      } else {
        return "/images/logo.png";
      }
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLotes();
    },

    deletar(leilao) {
      this.leilao_selecionado = leilao;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de leilao<b><br/>" + this.leilao_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/leilao/delete`, data)
              .then((response) => {
                this.showSuccessMessage("leilao deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatOnlyDate(date) {
      return moment(date).format("DD/MM/YYYY ");
    },
  },
};
</script>

<style>
.pdf-page-break {
  page-break-before: always !important;
}
</style>

<style>
/* Estilos para o modo de renderização do PDF */
.pdf-render-view {
  /* Para ajustar o tamanho da fonte de todo o texto do lote */
  font-size: 10pt !important; /* Aumente ou diminua este valor */

  /* Para ajustar o espaçamento vertical entre as linhas */
  line-height: 1.2 !important; /* Aumente para mais espaço, diminua para menos */

  /* ... outros resets ... */
}

/* Para ajustar o espaço entre a etiqueta (ex: "CPF:") e o valor */
.pdf-render-view .myBoard span {
  font-size: 12px;
  letter-spacing: 0.05rem;
}

.pdf-render-view .myBoard {
  line-height: 1 !important;
}

/* Para ajustar o espaço entre a etiqueta (ex: "CPF:") e o valor */
.pdf-render-view .myBoard b {
  font-size: 12px;
  letter-spacing: 0.05rem;
  display: inline-block !important;
  margin-right: 3pt !important; /* Aumente ou diminua este valor */
}

.report-footer b {
  font-size: 14px;
  letter-spacing: 0.05rem;
  margin-right: 3pt !important;
}
</style>

<style scoped>
.myBoard {
  font-size: 15px;
}

.myBoard b {
  color: #545353;
}

.myBoard span {
  color: #696969;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media print {
  .lote-card {
    page-break-inside: avoid;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}

.realizado {
  text-decoration: line-through;
}
</style>
